import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import ServiceBoxTiny from '../../../Shared/ServiceBox/ServiceBoxTiny/ServiceBoxTiny';
import {toAllActionButtonText} from '../productsAndServicesBlockSlice';
import {isMobile} from 'react-device-detect';
import {Button} from 'reactstrap';

const CategoryName = (props) => {
  return (
    <div className='category-name d-flex justify-content-between'>
      <div className='d-flex'>
        <span>
          <Image src={require(`../images/${props.imageName}.svg`)} alt='start' />
        </span>
        <span className='pr-2 title'>{props.title}</span>
      </div>
      {props.actions?.length > 0 && (
        <>
          {!isMobile ? (
            <div className='d-flex'>
              {props.actions.map((option, index) => {
                const contentType = typeof option;
                const actionUrl = contentType === 'object' ? option.actionUrl?.value : option.actionUrl;
                return (
                  <ServiceBoxTiny
                    key={index}
                    isHaveBadge={contentType === 'object' ? option.isNew.value : option.isNew}
                    badgeText={'חדש'}
                    actionName={contentType === 'object' ? option.actionName?.value : option.actionName}
                    callback={() => props.goToAction(actionUrl)}
                  />
                );
              })}
              {props.allActionButtonText && (
                <ServiceBoxTiny
                  isHaveBadge={false}
                  actionName={props.allActionButtonText}
                  isBold={true}
                  callback={() => {
                    props.goToAllAction(props.type);
                  }}
                  backgroundColorProperty={toAllActionButtonText.color}
                />
              )}
            </div>
          ) : (
            <Button color='link cellcomColor pl-0' onClick={() => props.goToAllAction(props.type)}>
              {toAllActionButtonText.mobileText}
            </Button>
          )}
        </>
      )}
    </div>
  );
};
export default CategoryName;
